
import { getPatientCurrentInsurance, getPatientInsurancesDetails, getPatientInsuredPerson, getPatientMasterData } from './actions/PatientActions';
import { connect } from 'react-redux';
import InsuranceForm from './insurance_form';
import React from 'react';
class Insurance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeInsurance: 'primary',
      patientId: props.patientId,
      CardIssueDate: null,
      enableSecondary: false,
      enableTertiary: false,
      patientMasterData: [],
      insurancePlanTypes: [],
    };
  }

  componentWillMount() {
    let masterData = {
      'masterdata': 'MASTERWEEKDAYS,staffavailability,MASTERGENDER,MASTERSTATE,MASTERCOUNTRY,MASTERRELATIONSHIP,INSURANCEPLANTYPE,MASTERINSURANCECOMPANY,SIGNATUREONFILE,INSUREDPERSONRELATIONSHIP',
    };
    this.props.getPatientMasterData(masterData);
    if (this.state.patientId) {
      this.props.getPatientInsurancesDetails(this.state.patientId);
    }
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.patientInsuranceDetails && nextProps.patientInsuranceDetails !== this.props.patientInsuranceDetails) {
      let patientInsurance = nextProps.patientInsuranceDetails.PatientInsurance;
      if (patientInsurance && patientInsurance.length) {
        this.setState({
          enableSecondary: patientInsurance.length > 0 ? true : false,
          enableTertiary: patientInsurance.length > 1 ? true : false,
        });
      }
    }

  }

  activeHandler = (clickedLI) => {
    this.setState({ activeInsurance: clickedLI }, () => {
    });
  };

  resolveJavascript = () => {
    return '#';
  }

  render() {
    const { patientInsuranceDetails } = this.props;

    let currentInsuranceDetails = null;
    if (patientInsuranceDetails && patientInsuranceDetails.PatientInsurance) {
      let patientInsurances = patientInsuranceDetails.PatientInsurance || [],
        insuredPersons = patientInsuranceDetails.InsuredPerson || [],
        selectedInsTypeId = null;
      if (this.state.activeInsurance === 'primary') {
        selectedInsTypeId = this.props.primaryInsPlanTypeId;
      } else if (this.state.activeInsurance === 'secondary') {
        selectedInsTypeId = this.props.secondaryInsPlanTypeId;
      } else {
        selectedInsTypeId = this.props.tertiaryInsPlanTypeId;
      }

      let insuranceArray = [];
      patientInsurances.forEach((insuranceObj) => {
        if (insuranceObj.insurancePlanTypeID === selectedInsTypeId) {
          let InsuredPersonObj = insuredPersons.find((obj) => obj.patientInsuranceID === insuranceObj.id);
          insuranceArray.push({
            ...insuranceObj,
            'insuredPerson': InsuredPersonObj,
          });
        }
      });
      if (insuranceArray.length) {
        currentInsuranceDetails = {
          'insurance': insuranceArray,
        };
      }
    }

    return (
      <div className="readmin-form custom_form">
        <ul className="tabs-sm">
          <li
            onClick={() => this.activeHandler('primary')}
            className={this.state.activeInsurance === 'primary' ? 'active' : ''}>
            <a href={this.resolveJavascript()}><i className="flaticon flaticon-medical-2"></i> Primary Insurance</a>
          </li>
          {this.state.enableSecondary ?
            <li
              onClick={() => this.activeHandler('secondary')}
              className={this.state.activeInsurance === 'secondary' ? 'active' : ''}>
              <a href={this.resolveJavascript()}><i className="flaticon flaticon-shield-1"></i> Secondary Insurance</a>
            </li>
            : <li><a href={this.resolveJavascript()}><i className="flaticon flaticon-shield-1"></i> Secondary Insurance</a></li>}
          {this.state.enableTertiary ?
            <li
              onClick={() => this.activeHandler('tertiary')}
              className={this.state.activeInsurance === 'tertiary' ? 'active' : ''}>
              <a href={this.resolveJavascript()}><i className="flaticon flaticon-insurance-1"></i> Tertiary Insurance</a>
            </li>
            : <li><a href={this.resolveJavascript()}><i className="flaticon flaticon-insurance-1"></i> Tertiary Insurance</a></li>}
        </ul>
        <InsuranceForm
          patientId={this.props.patientId}
          primaryInsPlanTypeId={this.props.primaryInsPlanTypeId}
          secondaryInsPlanTypeId={this.props.secondaryInsPlanTypeId}
          tertiaryInsPlanTypeId={this.props.tertiaryInsPlanTypeId}
          patientMasterData={this.state.patientMasterData}
          CardIssueDate={this.state.CardIssueDate}
          insuranceType={this.state.activeInsurance}
          activeHandler={this.activeHandler}
          currentInsuranceDetails={currentInsuranceDetails}
          handlePatientTabChange={this.props.handlePatientTabChange} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let patientMasterData = state.patient.patientMasterData
    , primaryInsPlanTypeId = null
    , secondaryInsPlanTypeId = null
    , tertiaryInsPlanTypeId = null;

  if (patientMasterData && patientMasterData.insurancePlanType) {
    patientMasterData.insurancePlanType.forEach((obj) => {
      if (obj.value.toLowerCase() === 'primary') {
        primaryInsPlanTypeId = obj.id;
      } else if (obj.value.toLowerCase() === 'secondary') {
        secondaryInsPlanTypeId = obj.id;
      } else if (obj.value.toLowerCase() === 'tertiary') {
        tertiaryInsPlanTypeId = obj.id;
      }
    });
  }

  let patientInsuranceDetails = null;
  if (state.patient.patientInsuranceDetails && state.patient.patientInsuranceDetails.data) {
    patientInsuranceDetails = state.patient.patientInsuranceDetails.data;
  }
  return {
    primaryInsPlanTypeId: primaryInsPlanTypeId,
    secondaryInsPlanTypeId: secondaryInsPlanTypeId,
    tertiaryInsPlanTypeId: tertiaryInsPlanTypeId,
    patient_insurance: state.patient.patient_insurance,
    patientInsuranceDetails: patientInsuranceDetails,
    get_patient_current_insurance: state.patient.patientActiveInsurance,
    // insurancePlanTypes: state.patient.patientMasterData.insurancePlanType,
  };

};

export default connect(mapStateToProps, { getPatientCurrentInsurance, getPatientInsuredPerson, getPatientInsurancesDetails, getPatientMasterData })(Insurance);



// WEBPACK FOOTER //
// ./src/modules/patients/insurance.js